import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import OrganizationTicketsPerBranch from "../../../components/organization/reports/daily/OrganizationTicketsPerBranch";
import {
  TICKET_SUMMARY_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const TicketsPerBranch = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={TICKET_SUMMARY_COLUMN_DEFINITIONS}
    descriptionKey="TicketsByBranch"
    title={`${reportIndex}. Tickets Per Branch`}
  >
    {({ data, renderConfig }) => (
      <OrganizationTicketsPerBranch reportIndex={reportIndex} data={data} renderConfig={renderConfig} />
    )}
  </DailyGeneratedReportPage>
);

export default TicketsPerBranch;
